import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Alert } from '../../../common/components/Alert';
import { selectAlert } from '../../../common/selectors/header';
import { helpCenterService } from '../../../common/services/helpCenter';
import { homepageService } from '../../../common/services/homepage/homepageService';
import { TLocalesKeys } from '../../../types';
import { emitter } from '../../../util/emitter';
import { headerDataHooks } from './Header.dataHooks';
import { HomepageHeader } from './HomepageHeader';
import s from './styles.scss';

export const Header: FC = () => {
  const { t } = useTranslation();
  const alert = useSelector(selectAlert);

  const closeChatbot = useCallback(
    () => emitter.emit('toggleChatbotVisible', false),
    [],
  );

  // TODO:homepage can be removed after merge 'specs.engage.enableHomepage'
  if (helpCenterService.isFullWidth) {
    return (
      <>
        <div className={s.headerFullPage}>
          <h2>{t<TLocalesKeys>('subheader_title')}</h2>
          <div className={s.headline}>
            {t<TLocalesKeys>('subheader_headline')}
          </div>
        </div>
        {alert && (
          <div data-hook={headerDataHooks.alertBanner()}>
            <Alert {...alert} />
          </div>
        )}
      </>
    );
  }

  if (homepageService.homepageEnabled) {
    return <HomepageHeader />;
  }

  return (
    <Box
      className={s.header}
      width="100%"
      height="60px"
      verticalAlign="middle"
      padding="12px 12px 12px 18px"
      flexShrink={0}
    >
      <TextButton
        skin="light"
        size="medium"
        underline="onHover"
        onClick={closeChatbot}
        dataHook={headerDataHooks.titleButton()}
      >
        <Text weight="bold" light={true} dataHook={headerDataHooks.titleText()}>
          {t<TLocalesKeys>('help_center_header_title_widget')}
        </Text>
      </TextButton>
    </Box>
  );
};
